<template>
  <div id="password-reset">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
    ></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form.vue";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";

var validator_messages = get_validator_messages();

export default {
  name: "PasswordResetConfirm",
  components: {
    Form
  },
  data() {
    return {
      buttons: [
        {
          name: "password-reset",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Zmień hasło",
              variant: "success",
              type: "submit",
              name: "password-reset",
              icon: "lock-fill"
            }
          ]
        }
      ],
      header: {
        title: "Zmień hasło",
        icon: "lock-fill"
      },
      messages: [
        {
          label: "Wysłaliśmy wiadomość z kodem umożliwiającym zmianę hasła.",
          variant: "success"
        },
        {
          label: "Wprowadź kod i nowe hasło.",
          variant: "info"
        }
      ],
      model: {
        code: null,
        password: null
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "text",
                label: "Kod",
                model: "code",
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "password",
                label: "Nowe hasło",
                model: "password",
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              }
            ]
          }
        ]
      },
      options: {
        validateAfterChanged: true,
        validateAsync: true
      }
    };
  },
  methods: {
    form_submit: function(model) {
      var username = this.$localStorage.get("password_reset_email");
      Vue.CognitoAuth.confirm_password(
        {
          username: username,
          confirmation_code: model.code,
          password: model.password
        },
        this.password_reset_success,
        this.password_reset_failure
      );
    },
    password_reset_success: function() {
      this.$router.push({ name: "Login" });
    },
    password_reset_failure: function(err) {
      this.messages = [];
      this.messages = [
        {
          label: err,
          variant: "danger"
        }
      ];
    }
  },
  mounted() {
    this.$nextTick(function() {
      var username = this.$localStorage.get("password_reset_email");
      if (!username) {
        this.$router.push({ name: "PasswordReset" });
      }
    });
  }
};
</script>

<style>
@media (min-width: 768px) {
  #password-reset .form-container {
    max-width: 520px;
  }
}
</style>
